import { render } from "./CheckoutFinish.vue?vue&type=template&id=2f74ad01"
import script from "./CheckoutFinish.vue?vue&type=script&lang=js"
export * from "./CheckoutFinish.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__